import React, { useEffect, useState } from 'react'

import Loader from 'components/common/Loader'
import VideoTrack from 'components/VideoTrack/VideoTrack'
import { getIdentity } from 'helpers/twilio'
import usePublications from 'hooks/usePublications/usePublications'
import useTrack from 'hooks/useTrack/useTrack'

import { Container, Name, Wrapper } from './styles'

const ScreenShare = ({ participant }) => {
    const [isLoading, setLoading] = useState(true)
    const [publication, setPublication] = useState(null)

    const publications = usePublications(participant)
    const track = useTrack(publication, participant)

    useEffect(() => {
        const screenPublication = publications.find(p =>
            p.trackName.includes('screen')
        )

        if (screenPublication) {
            setLoading(false)
            setPublication(screenPublication)
        }
    }, [publications])

    const element = React.useMemo(() => {
        console.count('ScreenShare Component')

        if (!track) return null

        const presenter = getIdentity(
            participant?.identity
        )?.firstName?.toLowerCase()

        return (
            <Container>
                {isLoading ? (
                    <Loader />
                ) : (
                    <Wrapper>
                        {presenter && <Name>{presenter} is presenting</Name>}
                        <VideoTrack
                            track={track}
                            priority="high"
                            enableScreenShare
                        />
                    </Wrapper>
                )}
            </Container>
        )
    }, [track, isLoading])

    return element
}

export default ScreenShare
